// React for Website

import React, { useState, useEffect } from "react";
//outsource
import { Col, Input, Form } from "antd";

//components
import { useDispatch } from "react-redux";
import { getVoucherIdRandom } from "../../../store/voucher/voucher.action";

const VoucherId = ({ disabled, setVoucherId }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  const [id, setId] = useState("");
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();

  // -------------------------- FUNCTION --------------------------
  const onChange = (e) => {
    const value = e.target.value;
    console.log("value", value);
    setVoucherId(value);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(
      getVoucherIdRandom((id) => {
        const voucherId = id?.id;
        // form.setFieldsValue({ voucherId });
        setId(voucherId);
      })
    );
  }, [dispatch]);
  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      label="Marketing Campaign Code"
      name="packageId"
      rules={[
        {
          require: true,
          message: "Please input voucher Id",
        },
      ]}
    >
      <Input
        placeholder={id}
        maxLength={6}
        onChange={onChange}
        showCount
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default VoucherId;
